<template>
    <div @focusout="closeDropDown($event)" tabindex="-1">
        <div v-if="this.isCreditsInAllSatsEnabled === true && typeof creditCalculation.factor !== 'undefined' && creditCalculation.factor !== null && this.isCostExcluded !== true">
            <div @click="showDropDown = !showDropDown" class="credit-badge">
                <CoinSVG />
                <strong>{{ creditCalculation.factor }}</strong>
                /
                <ClockSVG v-if="this.creditCalculation.unit === 'milliseconds'" />
                <PageSVG v-else />

                <strong>{{ costRate }}</strong>

                <strong v-if="this.creditCalculation.unit === 'milliseconds'" class="mr-1">s</strong>
                <span :class="showDropDown ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></span>
            </div>
            <div tabindex="-1" v-show="showDropDown" class="credit-drop-down">
                <div>
                    <span>{{ translatedText }}</span>
                </div>
                <div>
                    <span>{{ translatedUnitText }}</span>
                    <div>
                        <strong>{{ this.creditCalculation.factor }}</strong>
                        <CoinSVG />
                    </div>
                </div>
                <div>
                    <span>{{ 'Your Balance' | trans }}</span>
                    <div>
                        <strong>{{ balance }}</strong>
                        <CoinSVG />
                    </div>
                </div>
                <button class="buy-credits-button" @click="openPaymentModalCreditAllSatsEnabled">
                    <strong class="align-items-center d-flex">
                        <CoinSVG class="mr-1" />{{ 'Get Credits' | trans }}</strong
                    >
                    <span class="fa fa-arrow-right lh-inherit"></span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { eventBus } from '../../../../lib/event-bus/event-bus';
import {
  UPLOADER_EVENT,
  INPUT_EVENT_DELETED,
  INPUT_EVENT_DONE,
  NEW_COST_EVENT
} from '../../../../lib-sat/uploader/core/event';
import { INPUT_STATUS_UPLOADER_DONE } from '../../../../lib-sat/uploader/core/consts';
import { registerPaymentModalHelper } from '../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper';
import { userManager } from '../../../../lib-sat/user/user-manager';
import TransFilter from './mixins/TransFilter.vue';
import CoinSVG from './form/icons/CoinSVG.vue';
import ClockSVG from './form/icons/ClockSVG.vue';
import PageSVG from './form/icons/PageSVG.vue';
import { translate } from '../../../helper/translate';
import { satGlobals } from '../../../sat/helper/sat-globals';
import creditCost from "./aicreatorstudio/components/Settings/CreditCost.vue";
import Credits from "../../../../lib-sat/payment/credits";

export default {
    name: 'UploaderCreditDisplay',
    mixins: [TransFilter],
    components: { CoinSVG, ClockSVG, PageSVG },
    data() {
        return {
            showDropDown: false,
            balance: 0,
            filesUploaded: [],
            user: {},
            creditCalculation: {},
            creditCosts: {},
            isCreditsInAllSatsEnabled: satGlobals.isCreditsInAllSatsEnabled(),
            isLegacyUser: false,
            isCostExcluded: false,
        };
    },
    created() {
        eventBus.listen(UPLOADER_EVENT, (uploaderEvent) => {
            if (uploaderEvent.event === INPUT_EVENT_DONE) {
                const inputs = window.qgUploader.getInputList()?._inputs;
                this.filesUploaded = inputs.filter((input) => input._status === INPUT_STATUS_UPLOADER_DONE);
            } else if (uploaderEvent.event === INPUT_EVENT_DELETED) {
                const inputs = window.qgUploader.getInputList()?._inputs;
                this.filesUploaded = inputs.filter((input) => input._status === INPUT_STATUS_UPLOADER_DONE);
            }

          this.calculateCost();
        });

        eventBus.listen(NEW_COST_EVENT, (uploaderEvent) => {

          Credits.getActiveCost(uploaderEvent.data.cost, uploaderEvent.data.target).then((cost) => {
            this.creditCalculation = cost;
            if (null !== cost && cost.rate > 0){
              this.availableCredits();
            } else {
              this.isCreditsInAllSatsEnabled = false;
            }
          });
        });


        this.creditCosts = window.pageConfig.creditCalculation;

        this.calculateCost();

      //this.isExcluded(this.creditCalculation);
    },
    methods: {
      async calculateCost() {
        let cost = await Credits.getActiveCost(this.creditCosts);
        this.creditCalculation = cost;
        if (null !== cost && cost.rate > 0){
          await this.availableCredits();
        } else {
          this.isCreditsInAllSatsEnabled = false;
        }
      },
      async setCurrentCost() {
        this.user = await userManager.getUser();
        let productIds = this.user.getProductIds();
        this.isCostExcluded = cost.excluded.some(r => productIds.includes(parseInt(r)))

        return this.isCostExcluded;
      },
      async isExcluded(cost) {
        this.user = await userManager.getUser();
        let productIds = this.user.getProductIds();
        this.isCostExcluded = cost.excluded.some(r => productIds.includes(parseInt(r)))

        return this.isCostExcluded;
      },
        closeDropDown(e) {
            if (e?.relatedTarget?.className === 'credit-drop-down') {
                return;
            }
            if (e?.relatedTarget?.className === 'buy-credits-button') {
                return;
            }
            this.showDropDown = false;
        },
        openPaymentModal() {
            if (this.user.isPremium()) {
                registerPaymentModalHelper.openForPricingPremium();
            } else {
                registerPaymentModalHelper.openUpgrade();
            }
        },
        openPaymentModalCreditAllSatsEnabled() {
            registerPaymentModalHelper.openUpgrade();
        },
        async availableCredits() {
            this.user = await userManager.getUser();
            this.balance = this.user.getAvailableCredits();
            this.handleShow();
        },
        handleShow() {
            if (this.user.isLegacySubscription()) {
                this.isLegacyUser = true;
            } else {
                this.isLegacyUser = false;
            }
        },
    },
  computed: {
    creditCost() {
      return creditCost
    },
    totalCost() {
      if (this.isCreditsInAllSatsEnabled) {
        if (this.creditCalculation.unit === 'pages') {
          return this.filesUploaded.length * this.creditCalculation.factor;
        } else if (this.creditCalculation.unit === 'milliseconds') {
          return this.creditCalculation.factor;
        } else if (this.creditCalculation.unit === 'output') {
          return this.filesUploaded.length * this.creditCalculation.factor;
        }
      } else {
        if (window.pageConfig.target === 'text_to_image') {
          return this.user._isPremium || this.user._isEducational ? 4 : 2;
        } else {
          return this.filesUploaded.length;
        }
      }
    },
    translatedText() {
      let creditUnitText = '';
      let calculationRate = '';

      switch (this.creditCalculation.unit) {
        case 'pages':
          creditUnitText = translate('pages your file contain');
          calculationRate = this.creditCalculation.credit_cost_per_rate + ' ' + translate('pages');
          break;
        case 'milliseconds':
          creditUnitText = translate('task duration');
          calculationRate = this.creditCalculation.rate / 1000 + ' ' + translate('seconds');
          break;
        case 'output':
          creditUnitText = translate('output');;
          break;
      }

      return translate(
          `Credit consumption is determined by %creditUnitText%, deducting Credits for every %calculationRate% processed.`,
          {
            '%creditUnitText%': creditUnitText,
            '%calculationRate%': calculationRate,
          }
      );
    },
    translatedUnitText() {
      if (this.creditCalculation.unit === 'pages') {
        return translate(`%creditCalculationRate% pages`, {
          '%creditCalculationRate%': this.creditCalculation.rate,
        });
      } else if (this.creditCalculation.unit === 'milliseconds') {
        return translate(`%creditCalculationRate% seconds`, {
          '%creditCalculationRate%': this.creditCalculation.rate / 1000,
        });
      } else if (this.creditCalculation.unit === 'output') {
        return translate(`%creditCalculationRate% outputs`, {
          '%creditCalculationRate%': this.creditCalculation.rate,
        });
      }
    },
    costRate() {
      return this.creditCalculation.unit === 'milliseconds' ? this.creditCalculation.rate/1000 : this.creditCalculation.rate;
    }
  },
};
</script>

<style lang="scss">
.credit-badge {
    background-color: #ffaa00;
    padding: 10px 10px;
    gap: 7px;
    display: flex;
    align-items: center;
    height: 40px;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    &:hover {
        background-color: #cc8800;
    }
    div {
        display: flex;
        align-items: center;
        gap: 2px;
    }
}
.credit-drop-down {
    width: 290px;
    height: auto;
    display: flex;
    flex-direction: column;
    background-color: #1266f1;
    padding: 20px;
    border-radius: 4px;
    margin-top: 2px;
    gap: 12px;
    position: absolute;
    color: #fff;
    z-index: 999;
    div {
        display: flex;
        justify-content: space-between;
        div {
            background-color: #ffaa00;
            border-radius: 4px;
            padding: 0px 5px 0px 5px;
            align-items: center;
            display: flex;
            gap: 5px;
            color: #000;
        }
    }
    button {
        height: 38px;
        background-color: #ffaa00;
        border: 4px;
        padding: 7px 20px 7px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:hover {
            background-color: #cc8800;
        }
    }
}
@media (max-width: 400px) {
    .credit-drop-down {
        max-width: 60%;
    }
}
@media (max-width: 300px) {
    .buy-credits-button {
        font-size: 0.8rem;
    }
    .credit-drop-down {
        max-width: 53%;
    }
}
</style>
